export default __webpack_public_path__ + "static/media/kitchen3-afterH-1920w.13b110dd.webp";